import {HttpEvent, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuthSessionServiceDelegate} from './services/delegate.auth.session.service';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(protected sessionService: AuthSessionServiceDelegate) {
  }

  /**
   * Intercepte les requète et complète les headers avec les données en session et la méthode d'authentification
   * @returns
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = req;
    let uri_prefix = environment.uri_prefix;

    if (req.url.includes(uri_prefix)) {
      //récupère les headers nécessaires à l'appel (session + token oAuth/OIDC)
      const headers = this.sessionService.isConfigured() ? this.sessionService.getHeaders() : null;
      if (headers) {
        requestToForward = req.clone({setHeaders: headers})
      }
    }

    return next.handle(requestToForward).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (req.url.includes('accessToken')) {
          //sauvegarde l'access token en session si l'endpoint le renvoie
          this.sessionService.setAccessTokenObject(event.body);
        }
      }
      return event;
    }));
  }
}
